export default {
	pg005:{
		expired:30000,
		relatedAPI:'',
	},
	mgab001:{
		expired:30000,
		relatedAPI:'og010'
	},
	mg010:{
		expired:30000,
		relatedAPI:'ms001,md003,oc003,ms011,ms013,lrp007,lrp001'
	},
}